// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nvBl","placeholdersHeader":"styles_placeholdersHeader___F2Dq","editorStyle":"styles_editorStyle__1T6u1","placeholdersBox":"styles_placeholdersBox__20R6z"};